import { useSearchParams } from "react-router-dom";

const useEditSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateQueryParams = (newParams) => {
    const updatedParams = new URLSearchParams(searchParams);

    Object.keys(newParams).forEach((key) => {
      if (newParams[key] === null || newParams[key] === undefined) {
        updatedParams.delete(key);
      } else {
        updatedParams.set(key, newParams[key]);
      }
    });

    setSearchParams(updatedParams);
  };

  return { searchParams, updateQueryParams };
};

export default useEditSearchParams;
